// extracted by mini-css-extract-plugin
export var active = "_dj-7";
export var container = "_dj-0";
export var evenWidth = "_dj-4";
export var large = "_dj-5";
export var outlet = "_dj-8";
export var slide = "_dj-2";
export var small = "_dj-6";
export var tab = "_dj-3";
export var tabs = "_dj-1";